<h1>{{'LOGIN.SELECT_PROVIDERS.SELECT.TITLE' | translate}}</h1>

<p>{{'LOGIN.SELECT_PROVIDERS.SELECT.MSG.LOGIN' | translate}}</p>

<div style="margin-top: 15px;">
    <app-icon-list [icons]="icons" (iconClick)="redirectToSelectedProvider($event)"></app-icon-list>
</div>

<div *ngIf="errorMsg" class="mat-error">
    {{ errorMsg | translate }}
</div>


<div style="margin-top: 15px;">
    <a (click)="commonFunc.getRedirectedByRequestId()">{{'BACK' | translate}}</a>
</div>
